import AutorizacaoContext from "context/autorizacaoContext";
import { useContext } from "react";

export const useAutorizacaoContext = () => useContext(AutorizacaoContext);
